module.exports = __webpack_public_path__ + "img/hero-fire-03.27f26d7c.png";